import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#3778C2'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#3778C2',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontSize: 12,
        fontStyle: 'bold',
    },
    description: {
        width: '85%',
        textAlign: 'right',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingRight: 8,
    },
    total: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 8,
    },
});

const InvoiceTableFooter2 = ({ items ,total2,dif}) => {
    const total1 = items.totalAmount
    // console.log(`InvoiceTableFooter2() :: total1: `, total1);
    const orderAmount = items?.paymentDetails?.orderAmount ?? undefined;
    const totalAmount = items?.paymentDetails?.totalAmount ?? undefined;
    const delivery = items?.paymentDetails?.delivery ?? undefined;
    // console.log(`InvoiceTableFooter2() :: orderAmount: `, orderAmount, ` totalAmount: `, totalAmount, ` delivery: `, delivery);

    // const total = items.map(item => item.qty * item.rate )
    //     .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
    //     const ij = 1/10
    //     console.log("ij",ij)
    //     const th = total*dif
    //     console.log("th",th)
    //     const dd = total - th
    return (
        <View style={styles.row}>
            <Text style={styles.description}>FINAL PRICE</Text>
            <Text style={styles.total}>{totalAmount}</Text>
        </View> 
    )
};

export default InvoiceTableFooter2;